import RemoveFilterActionHandler from './RemoveFilterActionHandler.js';
class RangeRemoveFilterActionHandler extends RemoveFilterActionHandler {
    process(query, payload) {
        const { facetId } = payload;
        query.getRequest().resetSearchFacetTypeFilter(facetId);
    }
}
export default RangeRemoveFilterActionHandler;
